import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { api } from './services/api'
import {
  loadControlPlaneConfig,
  isControlPlaneEnabled,
  installControlPlaneBearer,
} from './services/controlPlane'

async function bootstrap() {
  // Resolve the CP client flags before anything renders (fail-safe to legacy).
  await loadControlPlaneConfig()
  if (isControlPlaneEnabled()) {
    // Bearer-only under CP: never send the legacy L3 session cookie, or the L3
    // server's dark-mode session branch would win over the CP bearer.
    api.defaults.withCredentials = false
    installControlPlaneBearer(api)
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
